<script>
import { clearTokens, getAdminInfo } from '@/utils/token.js'

const RAIL_BREAKPOINT = 1280

export default {
    name: 'AdminLayout',
    data() {
        return {
            windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1920,
            navItems: [
                { title: '대시보드', icon: 'mdi-view-dashboard-outline', to: '/dashboard' },
                { title: '메인화면 관리', icon: 'mdi-monitor-dashboard', to: '/main-display', hqOnly: true },
                { title: '업무공유게시판', icon: 'mdi-clipboard-text-outline', to: '/work-share' },
                { title: '보관/이동 관리', icon: 'mdi-archive-arrow-down-outline', to: '/storage' },
                {
                    title: '재고 관리',
                    icon: 'mdi-warehouse',
                    children: [
                        { title: '상품별 재고관리', icon: 'mdi-package-variant-closed-check', to: '/inventory/products', hqOnly: true },
                        { title: '지점 입고확인', icon: 'mdi-truck-check-outline', to: '/inventory/transfers' },
                        { title: '재고 원장', icon: 'mdi-clipboard-list-outline', to: '/inventory/ledgers' },
                    ],
                },
                // 시세는 출처가 셋이다 - 국내 거래소(KRX 실시간), 해외 API 두 곳.
                // 앞으로 더 늘어날 것이므로 하나로 묶는다. /metal-price 경로는
                // 그대로 둔다: 이미 쓰고 있는 화면이라 바꾸면 북마크가 깨진다.
                {
                    title: '시세 관리',
                    icon: 'mdi-chart-line',
                    hqOnly: true,
                    children: [
                        { title: '시세 차트', icon: 'mdi-chart-areaspline', to: '/market/chart' },
                        { title: '시세 수수료', icon: 'mdi-sack-percent', to: '/market/fee-policies' },
                        { title: '현물시세 (금/은)', icon: 'mdi-gold', to: '/metal-price' },
                        { title: '해외 시세 이력 (금/은)', icon: 'mdi-history', to: '/market/overseas' },
                        { title: 'KRX 금현물 시세', icon: 'mdi-chart-timeline-variant', to: '/market/krx/trades' },
                        { title: 'KRX 수신 현황', icon: 'mdi-lan-connect', to: '/market/krx/status' },
                        { title: 'KRX 원천 전문', icon: 'mdi-code-braces-box', to: '/market/krx/frames' },
                        { title: 'KRX 원본 보관', icon: 'mdi-archive-outline', to: '/market/krx/archive' },
                    ],
                },
                { title: '회원 관리', icon: 'mdi-account-group-outline', to: '/members', hqOnly: true },
                {
                    title: 'B2B 관리',
                    icon: 'mdi-domain',
                    hqOnly: true,
                    children: [
                        { title: '업체분류 관리', icon: 'mdi-shape-plus-outline', to: '/b2b/company-categories' },
                        { title: '업체 관리', icon: 'mdi-office-building-outline', to: '/b2b/companies' },
                        { title: '전체 B2B 상품', icon: 'mdi-sale-outline', to: '/b2b/companies/all' },
                        { title: '증빙 발행요청', icon: 'mdi-file-document-check-outline', to: '/b2b/evidence-requests' },
                    ],
                },
                {
                    title: '상품 관리',
                    icon: 'mdi-package-variant',
                    children: [
                        { title: '입금계좌 관리', icon: 'mdi-bank-outline', to: '/products/accounts' },
                        // 카드(PG) 결제 최대 금액 - 상품 1개 · 1회 · 1일(2026-10-31)
                        { title: '결제 한도 관리', icon: 'mdi-credit-card-lock-outline', to: '/products/payment-limits', hqOnly: true },
                        { title: '배송비 관리', icon: 'mdi-truck-fast-outline', to: '/products/shipping-fees', hqOnly: true },
                        { title: '도서산간 지역 관리', icon: 'mdi-map-marker-radius-outline', to: '/products/remote-areas', hqOnly: true },
                        // 브랜드가 위다 - 카테고리는 브랜드 아래에 속하는 개념이라
                        // 메뉴도 그 순서여야 한다(2026-09-28 지시).
                        { title: '브랜드 관리', icon: 'mdi-factory', to: '/products/brands', hqOnly: true },
                        { title: '카테고리 관리', icon: 'mdi-tag-outline', to: '/products/categories', hqOnly: true },
                        { title: '상품라벨관리', icon: 'mdi-label-multiple-outline', to: '/products/labels', hqOnly: true },
                        { title: '배송/교환 안내 관리', icon: 'mdi-truck-delivery-outline', to: '/products/delivery-exchange-templates' },
                        { title: '상품 관리', icon: 'mdi-cube-outline', to: '/products' },
                    ],
                },
                { title: '주문 관리', icon: 'mdi-receipt-text-outline', to: '/orders' },
                { title: '정산 관리', icon: 'mdi-calculator-variant-outline', to: '/settlement' },
                { title: '방문수령/출고', icon: 'mdi-package-variant-closed', to: '/order-status' },
                {
                    title: '미디어허브',
                    icon: 'mdi-play-box-multiple-outline',
                    hqOnly: true,
                    children: [
                        { title: '메인배너 관리', icon: 'mdi-image-multiple-outline', to: '/media-hub/main-banners' },
                        { title: '통계', icon: 'mdi-chart-box-outline', to: '/media-hub/statistics' },
                        { title: '수집카테고리 관리', icon: 'mdi-shape-outline', to: '/media-hub/source-categories' },
                        { title: '수집사이트 관리', icon: 'mdi-web', to: '/media-hub/sources' },
                        { title: '미디어허브 카테고리 관리', icon: 'mdi-view-grid-outline', to: '/media-hub/categories' },
                        { title: '수집 콘텐츠 관리', icon: 'mdi-playlist-check', to: '/media-hub/contents' },
                        { title: '홈페이지 노출 콘텐츠 관리', icon: 'mdi-monitor-share', to: '/media-hub/exposures' },
                        { title: '이미지 제작 가이드', icon: 'mdi-image-check-outline', to: '/media-hub/image-guide' },
                    ],
                },
                {
                    title: '고객지원',
                    icon: 'mdi-lifebuoy',
                    children: [
                        { title: '1:1 문의', icon: 'mdi-forum-outline', to: '/inquiries' },
                        { title: '공지사항', icon: 'mdi-bullhorn-outline', to: '/notices', hqOnly: true },
                    ],
                },
                {
                    title: '지점 관리',
                    icon: 'mdi-store-outline',
                    children: [
                        { title: '지점 목록', icon: 'mdi-store-outline', to: '/branches' },
                        { title: '본사관리자 관리', icon: 'mdi-account-tie-outline', to: '/branches/head-admins', hqOnly: true },
                        { title: '영업일 관리', icon: 'mdi-calendar-check-outline', to: '/business-calendar' },
                    ],
                },
            ],
            adminInfo: { adminName: '', adminType: '' },
        }
    },
    computed: {
        rail() {
            return this.windowWidth < RAIL_BREAKPOINT
        },
        filteredNavItems() {
            const isHq = this.adminInfo.adminType === 'HQ'
            return this.navItems
                .filter(item => !(item.hqOnly && !isHq))
                .map(item => {
                    if (!item.children?.length) return item
                    const children = item.children.filter(ch => !(ch.hqOnly && !isHq))
                    return { ...item, children }
                })
                .filter(item => !item.children || item.children.length > 0)
        },
        adminInitial() {
            return this.adminInfo.adminName ? this.adminInfo.adminName.charAt(0) : '관'
        },
        adminLabel() {
            const typeMap = { HQ: '본사', DIRECT: '직영점', AGENCY: '대리점', FRANCHISE: '가맹점' }
            return typeMap[this.adminInfo.adminType] || ''
        },
        isProductGroupActive() {
            const path = this.$route?.path || ''
            return path.startsWith('/products')
        },
        isCustomerSupportGroupActive() {
            const path = this.$route?.path || ''
            return path.startsWith('/inquiries') || path.startsWith('/notices') || path.startsWith('/faqs')
        },
        isMediaHubGroupActive() {
            const path = this.$route?.path || ''
            return path.startsWith('/media-hub')
        },
        isInventoryGroupActive() {
            const path = this.$route?.path || ''
            return path.startsWith('/inventory')
        },
        isB2bGroupActive() {
            const path = this.$route?.path || ''
            return path.startsWith('/b2b')
        },
        isMarketGroupActive() {
            const path = this.$route?.path || ''
            return path.startsWith('/metal-price') || path.startsWith('/market')
        },
    },
    mounted() {
        this.adminInfo = getAdminInfo()
        window.addEventListener('resize', this.onResize)
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        onResize() {
            this.windowWidth = window.innerWidth
        },
        logout() {
            clearTokens()
            this.$router.push('/login')
        },
        isGroup(item) {
            return Array.isArray(item.children) && item.children.length > 0
        },
        isGroupDrawerActive(item) {
            if (item.title === '상품 관리') return this.isProductGroupActive
            if (item.title === '고객지원') return this.isCustomerSupportGroupActive
            if (item.title === '미디어허브') return this.isMediaHubGroupActive
            if (item.title === '재고 관리') return this.isInventoryGroupActive
            if (item.title === 'B2B 관리') return this.isB2bGroupActive
            if (item.title === '시세 관리') return this.isMarketGroupActive
            if (item.title === '지점 관리') return (this.$route?.path || '').startsWith('/branches') || (this.$route?.path || '').startsWith('/business-calendar')
            return false
        },
    },
}
</script>

<template>
    <v-navigation-drawer
        class="admin-sidebar-surface"
        permanent
        :rail="rail"
        color="white"
        elevation="2"
        width="256"
    >
        <v-list-item class="py-4 px-4">
            <template #prepend>
                <v-icon color="primary" size="28">mdi-gold</v-icon>
            </template>
            <v-list-item-title class="text-h6 font-weight-bold text-primary">
                Goldnara Admin
            </v-list-item-title>
        </v-list-item>
        
        <v-divider />
        
        <v-list density="compact" nav class="mt-2">
            <template v-for="item in filteredNavItems" :key="item.title">
                <v-list-group v-if="isGroup(item)" :value="item.title">
                    <template #activator="{ props: groupProps }">
                        <v-tooltip :text="item.title" location="right" :disabled="!rail">
                            <template #activator="{ props: tooltipProps }">
                                <v-list-item
                                    v-bind="{ ...groupProps, ...tooltipProps }"
                                    :prepend-icon="item.icon"
                                    :title="item.title"
                                    active-color="primary"
                                    rounded="lg"
                                    class="mb-1"
                                    :active="isGroupDrawerActive(item)"
                                />
                            </template>
                        </v-tooltip>
                    </template>
                    
                    <v-tooltip
                        v-for="child in item.children"
                        :key="child.to"
                        :text="child.title"
                        location="right"
                        :disabled="!rail"
                    >
                        <template #activator="{ props: tooltipProps }">
                            <v-list-item
                                v-bind="tooltipProps"
                                :prepend-icon="child.icon"
                                :title="child.title"
                                :to="child.to"
                                active-color="primary"
                                rounded="lg"
                                class="mb-1"
                            />
                        </template>
                    </v-tooltip>
                </v-list-group>
                
                <v-tooltip v-else :text="item.title" location="right" :disabled="!rail">
                    <template #activator="{ props: tooltipProps }">
                        <v-list-item
                            v-bind="tooltipProps"
                            :prepend-icon="item.icon"
                            :title="item.title"
                            :to="item.to"
                            active-color="primary"
                            rounded="lg"
                            class="mb-1"
                        />
                    </template>
                </v-tooltip>
            </template>
        </v-list>
        
        <template #append>
            <v-divider />
            <v-list density="compact" nav class="my-1">
                <v-tooltip text="로그아웃" location="right" :disabled="!rail">
                    <template #activator="{ props: tooltipProps }">
                        <v-list-item
                            v-bind="tooltipProps"
                            prepend-icon="mdi-logout"
                            title="로그아웃"
                            rounded="lg"
                            @click="logout"
                        />
                    </template>
                </v-tooltip>
            </v-list>
        </template>
    </v-navigation-drawer>
    
    <v-app-bar class="admin-topbar-surface" elevation="1" color="white" height="60">
        <v-app-bar-title>
      <span class="text-subtitle-1 font-weight-medium text-grey-darken-2">
        {{ $route.meta?.title || 'Goldnara Admin' }}
      </span>
        </v-app-bar-title>
        <template #append>
            <v-chip
                v-if="adminLabel"
                size="small"
                color="primary"
                variant="tonal"
                label
                class="mr-2"
            >
                {{ adminLabel }}
            </v-chip>
            <v-avatar color="primary" size="32" class="mr-3" style="cursor:pointer;">
                <span class="text-caption text-white font-weight-bold">{{ adminInitial }}</span>
            </v-avatar>
        </template>
    </v-app-bar>
    
    <v-main class="admin-main-surface">
        <v-container fluid class="pa-6 admin-main-container">
            <slot />
        </v-container>
    </v-main>
</template>

<style scoped>
.v-navigation-drawer .v-list-item--active {
    background-color: rgba(205, 178, 122, 0.12);
}

.admin-main-container {
    max-width: 1400px;
}
</style>
